<div class="flex flex-col py-8 justify-center min-h-screen container-padding">
  <div class="w-full max-w-md mx-auto">
    <div class="py-6 px-6 shadow rounded-2xl border-4 border-[var(--tertiary)] bg-[var(--white)]">
      <h2 class="uppercase text-[36px]/[48px] font-normal text-[var(--dark-orange)]">
        {{ 'completeProfile.title' | translate }}
      </h2>
      <div class="w-full border-t border-dotted mb-6 mt-2"></div>

      <form [formGroup]="profileForm" (submit)="onSubmit()">
        <div class="flex flex-col gap-6">
          <app-input [control]="profileForm.controls['name']" inputId="name" type="text"
            [label]="'completeProfile.fullName' | translate" placeholder="Juan Pérez" autocomplete="name"></app-input>

          <app-input-phone [control]="profileForm.controls['phone']" inputId="phone"
            [label]="'completeProfile.phone' | translate" autocomplete="tel"></app-input-phone>
        </div>

        <div class="mt-8">
          <app-button [submit]="true" [disabled]="isLoading"
            [text]="isLoading ? ('completeProfile.saving' | translate) : ('completeProfile.continue' | translate)"
            [fullWidth]="true"></app-button>
        </div>

        <div *ngIf="errorMessage" class="mt-4 font-bold text-[14px]/[14px] text-center" style="color: red;">
          {{ errorMessage }}
        </div>
      </form>
    </div>
  </div>
</div>
